import { Controller } from '@hotwired/stimulus'

const POSTHOG_FEATURE_FLAGS_AVAILABLE_EVENT = 'posthog:feature-flags-available'

export default class extends Controller {
  static targets = ['feature', 'control']
  static values = { key: String }

  get enabled() {
    return posthog.isFeatureEnabled(this.keyValue)
  }

  // *** Lifecycle

  connect() {
    document.addEventListener(
      POSTHOG_FEATURE_FLAGS_AVAILABLE_EVENT,
      this.handleFeatureFlagsAvailable.bind(this)
    )
  }

  disconnect() {
    document.removeEventListener(
      POSTHOG_FEATURE_FLAGS_AVAILABLE_EVENT,
      this.handleFeatureFlagsAvailable.bind(this)
    )
  }

  // *** Events

  handleFeatureFlagsAvailable() {
    if (this.hasFeatureTarget) {
      this.featureTarget.style.display = this.enabled ? 'block' : 'none'
    }

    if (this.hasControlTarget) {
      this.controlTarget.style.display = this.enabled ? 'none' : 'block'
    }
  }
}
